// extracted by mini-css-extract-plugin
module.exports = {"layout":"ViewLayoutConfiguration_layout__1DBOR"};